import { StringArrayMiddlewareUtils } from '../shared/middlewareUtils';
import { buildFullValueApiParams } from '../shared/valueUtils';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';

/**
 * 平台筛选器中间件工具
 * value 类型：string[]
 */
class PlatformMiddlewareUtils extends StringArrayMiddlewareUtils {
  convertToApiParams(
    item: IFilterItemConfig,
    filterValue?: string[],
    params?: unknown,
  ): Record<string, string[]> | null {
    return buildFullValueApiParams(item, filterValue, params);
  }
}

export default PlatformMiddlewareUtils;
